import * as React from 'react'
import { observer } from 'mobx-react'
import ModalViewModel from 'infra/ModalViewModel'
import {
  Dialog,
  DialogButton,
  DialogButtonGroup,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogIllustration,
  DialogTitle,
} from 'components/Dialog'
import { useBrandingSettings } from 'hooks/branding'
import sample from 'lodash/sample'

interface VanishedDialogProps {
  vm: ModalViewModel
}

const messages = [
  'Looks like someone beat you to it!',
  'Oooh you almost had it! You gotta be quicker than that!',
  'Oh no! Somebody swooped in and took this opportunity from right under your nose!',
]

export default observer(function VanishedDialog({ vm }: VanishedDialogProps) {
  const { corporateMode } = useBrandingSettings()
  const [message, setMessage] = React.useState(messages[0])
  // Get a random message every time we show the modal.
  React.useEffect(() => {
    if (vm.showing) {
      setMessage(sample(messages) ?? messages[0])
    }
  }, [vm.showing])

  return (
    <Dialog showing={vm.showing}>
      <DialogHeader>
        {!corporateMode && (
          <DialogIllustration
            src={require('assets/images/img_job-no-longer-available.svg')}
          />
        )}
        <DialogTitle>This opportunity has vanished!</DialogTitle>
        <DialogDescription>
          {message} The job is no longer available.
          <br />
          Please select another from the Opportunities screen.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter bordered>
        <DialogButtonGroup>
          <DialogButton onClick={vm.close}>Close</DialogButton>
        </DialogButtonGroup>
      </DialogFooter>
    </Dialog>
  )
})
